import VerificationEmailPhone from './VerificationEmailPhone';

export default VerificationEmailPhone;
